export default "__VITE_ASSET__DEHgoOYW__"